import { useIntl } from 'react-intl';

export function useMessages(checked: boolean, isPool: boolean) {
  const intl = useIntl();

  if (isPool && checked) {
    return {
      confirmTitle: intl.formatMessage({ defaultMessage: 'Complete Pool?' }),
      confirmDescription: intl.formatMessage({
        defaultMessage:
          'Marking this pool as complete will stop sourcing from this pool for this opening. Note: This action cannot be undone. The pool will move to a completed state.',
      }),
      confirmButtonLabel: intl.formatMessage({
        defaultMessage: 'Complete pool',
      }),
      notifySuccessMessage: intl.formatMessage({
        defaultMessage: 'Pool completed successfully!',
      }),
      notifyErrorMessage: intl.formatMessage({
        defaultMessage: 'Failed to complete pool!',
      }),
    };
  }

  if (checked) {
    return {
      confirmTitle: intl.formatMessage({ defaultMessage: 'Pause campaign' }),
      confirmDescription: intl.formatMessage({
        defaultMessage: 'Are you sure you want to pause this campaign?',
      }),
      confirmButtonLabel: intl.formatMessage({
        defaultMessage: 'Yes, Pause campaign',
      }),
      notifySuccessMessage: intl.formatMessage({
        defaultMessage: 'Campaign paused successfully!',
      }),
      notifyErrorMessage: intl.formatMessage({
        defaultMessage: 'Failed to pause campaign!',
      }),
    };
  }

  return {
    confirmTitle: intl.formatMessage({ defaultMessage: 'Resume campaign' }),
    confirmDescription: intl.formatMessage({
      defaultMessage: 'Are you sure you want to resume this campaign?',
    }),
    confirmButtonLabel: intl.formatMessage({
      defaultMessage: 'Yes, resume campaign',
    }),
    notifySuccessMessage: intl.formatMessage({
      defaultMessage: 'Campaign resumed successfully!',
    }),
    notifyErrorMessage: intl.formatMessage({
      defaultMessage: 'Failed to resume campaign!',
    }),
  };
}
